<template>
  <!-- 安全工器具 -->
  <!-- pc端 -->
  <div v-if="isPCFlag" class="solutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <topBigPic :topBgImg="topBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></topBigPic>

    <!-- 第二部分 -->
    <div class="containers">
      <div class="honor_header ">
        <h1 ref="HeaderTitle">产品简介</h1>
        <div class="mian_Info" ref="honorMain">
          <p>安全工器具产品基于计算机技术、物联网技术、实物ID技术、人脸识别技术、大数据分析技术等前沿科技，实现对工<br />器具的全生命周期管理、仓储条件感知与调节、无感知出入库、运行情况分析与展示、安措计划等功能，为安全生产<br />、降本增效提供支撑。</p>
        </div>
        <div class="honorImg" ref="honorImg">
          <div class="shade" ref="shadeHonorImg"></div>
          <img src="../../assets/imgs/solution/synopsis.jpg" ref="imgHonorImg">
        </div>
      </div>
    </div>

    <!-- 第三部分 -->
    <keyfeature :keyFeature="keyFeature"></keyfeature>

    <!-- 第四部分 -->
    <systemfeatures :systemFeatures="systemFeatures"></systemfeatures>

    <!-- 第五部分 -->
    <applicationresults :applicationResults="applicationResults"></applicationresults>

    <!-- 尾部公用组件 -->
    <bottomFooter :applicationResults="applicationResults"></bottomFooter>
  </div>
  <!-- 移动端 -->
  <div v-else class="mobileSolutionSafety">
    <!-- 第一部分顶部大图导航 -->
    <mobileTopBigPic :topBgImg="mobileTopBgImg" :bigTitle="bigTitle" :menuLi="menuLi"></mobileTopBigPic>
    <!-- 第二部分 -->
    <div class="mobile-about-part2">
      <div class="title ml71">
        产品简介
      </div>
      <div class="info mobile-container padding-bottom-213">
        安全工器具产品基于计算机技术、物联网技术、实物ID技术、人脸识别技术、大数据分析技术等前沿科技，实现对工器具的全生命周期管理、仓储条件感知与调节、无感知出入库、运行情况分析与展示、安措计划等功能，为安全生产、降本增效提供支撑。
      </div>
      <div class="bg"></div>
    </div>

    <!-- 第三部分 目标用户-->
    <mbKeyfeature :keyFeature="mbKeyFeature"></mbKeyfeature>

    <!-- 第四部分 -->
    <mbSystemfeatures :systemFeatures="mbSystemFeatures"></mbSystemfeatures>

    <!-- 第五部分 -->
    <mbApplicationresults :applicationResults="mbApplicationResults" :specialStyle="true"></mbApplicationresults>
    <!-- 尾部公用组件 -->
    <mobileBottomFooter></mobileBottomFooter>
  </div>

</template>

<script>
import topBigPic from "@/components/global/topBigPic.vue";
import bottomFooter from "@/components/global/bottomFooter.vue";
import keyfeature from "@/components/solution/keyfeature.vue";
import systemfeatures from "@/components/solution/systemfeatures.vue";
import applicationresults from "@/components/solution/applicationresults.vue";
import mobileTopBigPic from "@/components/global/mobileTopBigPic";
import mobileBottomFooter from "@/components/global/mobileBottomFooter.vue";
import mbKeyfeature from "@/components/solution/mbKeyfeature.vue";
import mbSystemfeatures from "@/components/solution/mbSystemfeatures.vue";
import mbApplicationresults from "@/components/solution/mbApplicationresults.vue";

import animationUtils from "@/utils/animationUtils.js";
import { isPC } from "@/utils/tools.js";

export default {
  name: "solutionSafety",
  data() {
    return {
      // specialStyle:true,
      isPCFlag: true,
      //顶部导航数据
      topBgImg: require("../../assets/imgs/solution/topbg.jpg"),
      mobileTopBgImg: require("../../assets/imgs/mobileSolution/topbg.jpg"),
      bigTitle: {
        znTitle: "安全工器具",
        enTitle: "MANAGEMENT OF TOOLS AND INSTRUMENTS",
      },
      menuLi: {
        sortOne: {
          title: "解决方案",
          children: [
            {
              name: "产品中心",
              active: false,
              url: "/comdedeauto",
            },
            {
              name: "解决方案",
              active: true,
              url: "/solutionadmi",
            },
            {
              name: "新闻动态",
              active: false,
              url: "/companyNews",
            },
            {
              name: "关于我们",
              active: false,
              url: "/companyprofile",
            },
            {
              name: "职等你来",
              active: false,
              url: "/jobmarket",
            },
          ],
        },

        sortTwo: {
          title: "安全工器具",
          children: [
            {
              name: "人员准入",
              active: false,
              url: "/solutionadmi",
            },
            {
              name: "安全工器具",
              active: true,
              url: "/solutionSafety",
            },
            {
              name: `“项目+资产”移动作业系统`,
              active: false,
              url: "/projectassets",
            },
          ],
        },
      },
      //主要功能
      keyFeature: {
        part1: [
          {
            bg: require("../../assets/imgs/solution/life_cycle_management.png"),
            title: "生命周期管理",
            info: "包含工器具采购、验收、试验、派发、使用、报废的全过程管控，通过实物ID，实现对安全工器具的全生命周期追溯。",
          },
          {
            bg: require("../../assets/imgs/solution/circumstances.png"),
            title: "环境感知调节",
            info: "借助物联网技术实时感知库房温度、湿度、光照等状态，并进行自动调节，工作人员也可远程查看和调整。",
          },
          {
            bg: require("../../assets/imgs/solution/out_in_warehouse.png"),
            title: "无感知出入库",
            info: "通过实物ID及人脸识别技术，自动关联作业计划，智能生产领用清单，RFID通道门自动感应识别工器具，实现无感知出入库。",
          },
          {
            bg: require("../../assets/imgs/solution/analysis_display.png"),
            title: "运行分析展示",
            info: "通过中控大屏和站端大屏，对各项数据进行统计分析后进行全方位可视化展示，对仓库全方位状态综合把控。",
          },
          {
            bg: require("../../assets/imgs/solution/safety_precautions.png"),
            title: "安措计划管理",
            info: "遵照国家工器具配置标准结合实际使用数据，计算推荐安措参考计划，安措计划审批工作流支撑班组→区县→市级，多级审批，清晰透明，逐级追溯，记录完备。",
          },
        ],
        part2: [
          {
            bg: require("../../assets/imgs/solution/multi_terminal.png"),
            title: "多终端交互",
            info: "PC-后台端、APP-移动端、中控大屏多终端交互，数据互联互通。",
          },
        ],
      },
      mbKeyFeature: {
        part1: [
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/life_cycle_management.png"),
            title: "生命周期管理",
            info: "包含工器具采购、验收、试验、派发、使用、报废的全过程管控，通过实物ID，实现对安全工器具的全生命周期追溯。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/circumstances.png"),
            title: "环境感知调节",
            info: "借助物联网技术实时感知库房温度、湿度、光照等状态，并进行自动调节，工作人员也可远程查看和调整。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/out_in_warehouse.png"),
            title: "无感知出入库",
            info: "通过实物ID及人脸识别技术，自动关联作业计划，智能生产领用清单，RFID通道门自动感应识别工器具，实现无感知出入库。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/analysis_display.png"),
            title: "运行分析展示",
            info: "通过中控大屏和站端大屏，对各项数据进行统计分析后进行全方位可视化展示，对仓库全方位状态综合把控。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/safety_precautions.png"),
            title: "安措计划管理",
            info: "遵照国家工器具配置标准结合实际使用数据，计算推荐安措参考计划，安措计划审批工作流支撑班组→区县→市级，多级审批，清晰透明，逐级追溯，记录完备。",
          },
          {
            bg: require("../../assets/imgs/mobileSolution/solutionSafety/multi_terminal.png"),
            title: "多终端交互",
            info: "PC-后台端、APP-移动端、中控大屏多终端交互，数据互联互通。",
          },
        ],
      },
      //系统特色
      systemFeatures: {
        part1: [
          {
            img: require("../../assets/imgs/solution/lifecycle.jpg"),
            index: "01",
            info: "全生命周期，业务流程闭环",
          },
          {
            img: require("../../assets/imgs/solution/yidong_management.jpg"),
            index: "02",
            info: "移动化管理，使用便捷高效",
          },
          {
            img: require("../../assets/imgs/solution/out_in_yidong.jpg"),
            index: "03",
            info: "无感出入库，管理降本增效",
          },
        ],
        part2: [
          {
            img: require("../../assets/imgs/solution/zhineng.jpg"),
            index: "04",
            info: "智能化识别，避免错拿误拿",
          },
          {
            img: require("../../assets/imgs/solution/circumstances_jiance.jpg"),
            index: "05",
            info: "全方位监测，环境智能调节",
          },
          {
            img: require("../../assets/imgs/solution/keshihua.jpg"),
            index: "06",
            info: "可视化展示，辅助支撑决策",
          },
        ],
      },
      mbSystemFeatures: {
        part1: [
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/lifecycle.jpg"),
            index: "01",
            info: "全生命周期，业务流程闭环",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/yidong_management.jpg"),
            index: "02",
            info: "移动化管理，使用便捷高效",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/out_in_yidong.jpg"),
            index: "03",
            info: "无感出入库，管理降本增效",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/zhineng.jpg"),
            index: "04",
            info: "智能化识别，避免错拿误拿",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/circumstances_jiance.jpg"),
            index: "05",
            info: "全方位监测，环境智能调节",
          },
          {
            img: require("../../assets/imgs/mobileSolution/solutionSafety/keshihua.jpg"),
            index: "06",
            info: "可视化展示，辅助支撑决策",
          },
        ],
      },
      applicationResults: {
        bg: require("../../assets/imgs/solution/applicationresults_gj.jpg"),
        dataLi: {
          part1: [
            {
              img: require("../../assets/imgs/solution/applicationresults_gj01.png"),
              title: "基于实物ID，全生命周期管理",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_gj02.png"),
              title: "作业票贯通，强化作业管控力",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_gj03.png"),
              title: "跨区域协同，提升设备利用率",
            },
            {
              img: require("../../assets/imgs/solution/applicationresults_gj04.png"),
              title: "无感出入库，提升记录准确率",
            },
          ],
          part2: [],
        },
      },
      mbApplicationResults: {
        bg: require("../../assets/imgs/mobileSolution/solutionSafety/applicationresults_gj.jpg"),
        dataLi: {
          part1: [
            {
              img: require("../../assets/imgs/mobileSolution/solutionSafety/applicationresults_gj01.png"),
              title: "基于实物ID，全生命周期管理",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionSafety/applicationresults_gj02.png"),
              title: "作业票贯通，强化作业管控力",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionSafety/applicationresults_gj03.png"),
              title: "跨区域协同，提升设备利用率",
            },
            {
              img: require("../../assets/imgs/mobileSolution/solutionSafety/applicationresults_gj04.png"),
              title: "无感出入库，提升记录准确率",
            },
          ],
        },
      },
    };
  },
  created() {
    this.isPCFlag = isPC();
  },
  mounted() {
    this.isPCFlag ? window.addEventListener("scroll", this.menu) : "";
  },
  beforeDestroy() {
    //在加载时添加了scroll监听，如果不销毁，到下一个页面时，没有主动销毁，会报错'offsetTop' of undefined。因此，需要在页面跳转前销毁此监听
    this.isPCFlag ? window.removeEventListener("scroll", this.menu) : "";
  },
  methods: {
    //滚动条监听
    menu() {
      /**
       * animations方法的第一个参数是需要动画的dom元素的高度，
       * 第二个参数是需要加动画的dom元素的样式列表数组，
       * 第三参数是动画类型（样式类名）activeTitle：文字动画，activeShade图片出现前的遮罩动画，activeTitle图片动画
       */
      //第二部分标题动画
      let HeaderTitleOffsetTop = this.$refs.HeaderTitle.offsetTop; //获取当前元素距离文档顶部的高度
      let HeaderTitle = this.$refs.HeaderTitle.classList;
      //
      animationUtils.animations(
        HeaderTitleOffsetTop,
        HeaderTitle,
        "activeTitle"
      );

      //第二部分图的动画
      let honorImgOffsetTop = this.$refs.honorImg.offsetTop; //获取当前元素距离文档顶部的高度
      let shadeHonorImg = this.$refs.shadeHonorImg.classList; //遮罩样式数组
      let imgHonorImg = this.$refs.imgHonorImg.classList; //图片样式数组
      animationUtils.animations(
        honorImgOffsetTop,
        shadeHonorImg,
        "activeShade"
      );
      animationUtils.animations(honorImgOffsetTop, imgHonorImg, "activeImg");

      //第二部分文字描述动画
      let honorMainOffsetTop = this.$refs.honorMain.offsetTop;
      let honorMainClassList = this.$refs.honorMain.classList;
      animationUtils.animations(
        honorMainOffsetTop,
        honorMainClassList,
        "activeTitle"
      );
    },
  },
  components: {
    topBigPic,
    bottomFooter,
    keyfeature,
    systemfeatures,
    applicationresults,
    mobileTopBigPic,
    mobileBottomFooter,
    mbKeyfeature,
    mbSystemfeatures,
    mbApplicationresults,
  },
};
</script>

<style lang="scss" scoped>
.mobileSolutionSafety {
  .padding-bottom-213 {
    padding-bottom: 213px;
  }

  .mobile-about-part2 {
    .title {
      width: 1720px;
      height: 180px;
      line-height: 180px;
      font-size: 156px;
      font-weight: 600;
      padding: 284px 0 174px;
      box-sizing: content-box;
      color: #000000;
    }
    .bg {
      height: 1152px;
      background: url(../../assets/imgs/mobileSolution/synopsis.jpg) no-repeat;
      background-size: cover;
    }
    .info {
      font-size: 71px;
      font-weight: 400;
      color: #323333;
      line-height: 128px;
      text-align: justify;
    }
  }
}
</style>